import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    signInText: {
      ...CommonFonts.darkBoldFont24,
      letterSpacing: 0.28,
    },
    banner: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    resetButton: {
      height: 60,
    },
    forgotText: {
      ...CommonFonts.grayFont20,
      cursor: "pointer",
    },
    contactText: {
      ...CommonFonts.grayFont18,
    },
  })
);

export default useStyles;
